import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import * as React from 'react';
import { DragDropContext, Draggable, Droppable, DroppableProvided } from '@hello-pangea/dnd';
import LearningCollectionEditStore from '../../Edit/Store';
import { browseAllFieldValue } from '../../Edit/Store/Types';
import { Section } from '../../Types';
import SectionContent from './SectionContent';
import { LearningCollectionEditFormResource } from '../../Edit/Store/Types';

interface Props {
  store: LearningCollectionEditStore;
  sections: NonEmptyList<Section>;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const ActiveLearningDesignExperiences: React.FC<Props> = ({
  store,
  sections,
  learningCollectionEditFormResource,
}) => (
  <DragDropContext onDragEnd={store.handleOnDragEndSections}>
    <Droppable droppableId="characters">
      {(provided: DroppableProvided) => (
        <div {...provided.droppableProps} ref={provided.innerRef}>
          {sections
            .filter((section) => !browseAllFieldValue(section.template))
            .map((section, index) => (
              <Draggable
                index={index}
                key={section.resource.payload.id}
                draggableId={String(section.resource.payload.id)}
              >
                {(provided) => (
                  <SectionContent
                    store={store}
                    section={section}
                    provided={provided}
                    learningCollectionEditFormResource={learningCollectionEditFormResource}
                  />
                )}
              </Draggable>
            ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </DragDropContext>
);

export default observer(ActiveLearningDesignExperiences);
